// extracted by mini-css-extract-plugin
export default {"genericTooltip":"GenericTooltip_genericTooltip__Oq6Vo"};